import { createFileRoute } from '@tanstack/react-router';
import { ChecklistTemplatesPage } from '@/features/field';

export const Route = createFileRoute('/_auth/o/$orgId/admin/checklists')({
  component: ChecklistTemplatesRoute,
});

function ChecklistTemplatesRoute() {
  const { orgId } = Route.useParams();
  return <ChecklistTemplatesPage orgId={orgId} />;
}
